export var PlayerJumpShipReasonType;
(function (PlayerJumpShipReasonType) {
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["REGISTER"] = 0] = "REGISTER";
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["PLAYER_TO_PLATFORM"] = 1] = "PLAYER_TO_PLATFORM";
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["LONG_TIME_NO_LOGIN"] = 2] = "LONG_TIME_NO_LOGIN";
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["STUPID_PLAYER"] = 3] = "STUPID_PLAYER";
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["ABANDON_PLAYER"] = 4] = "ABANDON_PLAYER";
    PlayerJumpShipReasonType[PlayerJumpShipReasonType["CUSTOM"] = 10] = "CUSTOM";
})(PlayerJumpShipReasonType || (PlayerJumpShipReasonType = {}));
//# sourceMappingURL=PlayerJumpShipReasonType.js.map